import axios from 'axios';

// DEĞİŞİKLİK: API_URL, canlı backend adresini gösterecek şekilde güncellendi.
const API_URL = process.env.REACT_APP_API_URL + '/api/services/';

// Yeni bir hizmet oluştur
const createService = async (serviceData, token) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.post(API_URL, serviceData, config);
  return response.data;
};

// Tüm hizmetleri getir
const getServices = async () => {
  const response = await axios.get(API_URL);
  return response.data;
};

// Bir hizmeti güncelle
const updateService = async (serviceId, serviceData, token) => {
  const config = {
    headers: {
      // Not: Henüz token koruması aktif değilse bu başlık backend'de kullanılmayabilir,
      // ancak geleceğe dönük olarak eklemek iyi bir pratiktir.
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await axios.put(API_URL + serviceId, serviceData, config);
  return response.data;
};

// Bir hizmeti sil
const deleteService = async (serviceId, token) => {
    const config = {
        headers: {
        Authorization: `Bearer ${token}`,
        },
    };
    const response = await axios.delete(API_URL + serviceId, config);
    return response.data;
};

const serviceService = {
  createService,
  getServices,
  updateService, // Yeni fonksiyonu export et
  deleteService,
};

export default serviceService;